import { render, staticRenderFns } from "./manageUniversityExamQuestions.vue?vue&type=template&id=83d4a5ec"
import script from "./manageUniversityExamQuestions.vue?vue&type=script&lang=js"
export * from "./manageUniversityExamQuestions.vue?vue&type=script&lang=js"
import style0 from "./manageUniversityExamQuestions.vue?vue&type=style&index=0&id=83d4a5ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports